<template>
  <div class="page_legalSubjectInfo">
    <div class="memberTop departMemberTop">
      <div class="memberInput">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>法务主体信息</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName == 'first' ? '基础信息' : activeName == 'second' ? '财务信息' : '其他资料'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础信息" name="first"></el-tab-pane>
          <el-tab-pane label="财务信息" name="second"></el-tab-pane>
          <el-tab-pane label="成功案例" name="third"></el-tab-pane>
          <el-tab-pane label="合同模板" name="fourth"></el-tab-pane>
          <el-tab-pane label="报价体系" name="fifth"></el-tab-pane>
        </el-tabs>

        <div class="info_Box flex" v-if="activeName=='first'">
          <div class="info_Box_left">
            <div class="info_item flex">
              <div class="info_item_title">公司名称：</div>
              <div class="info_item_content">{{ legForm.CompanyName }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">注册资金：</div>
              <div class="info_item_content">{{ legForm.RegisteredCapital || legForm.RegisteredCapital==0 ? legForm.RegisteredCapital==0 ? '分公司无注册资金' : legForm.RegisteredCapital + '万' : '' }}</div>
            </div>
            <div class="info_item flex aic">
              <div class="info_item_title">企业信用代码：</div>
              <div class="info_item_content">{{ legForm.TaxNum ? legForm.TaxNum : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">注册地点：</div>
              <div class="info_item_content">{{ legForm.RegisteredAddress && legForm.RegisteredAddress.indexOf('$$')>-1 ? legForm.RegisteredAddress.replace('$$','') : legForm.RegisteredAddress.split('/')[0].replace(/,/g,'-') + '；' + legForm.RegisteredAddress.split('/')[1] }}</div>
            </div>
            <div class="info_item flex aic">
              <div class="info_item_title">注册时间：</div>
              <div class="info_item_content">{{ legForm.RegisteredTime ? legForm.RegisteredTime.split('T')[0] : '' }}</div>
            </div>
            <div class="info_item flex aic">
              <div class="info_item_title">营业期限：</div>
              <div class="info_item_content">{{ legForm.BusinessTerm ? legForm.BusinessTerm == '2999-12-31T00:00:00' || legForm.BusinessTerm == '2999-12-31' ? '长期有效' : legForm.BusinessTerm.split('T')[0] : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">经营范围：</div>
              <div class="info_item_content">{{ legForm.BusinessScope ? legForm.BusinessScope : '' }}</div>
            </div>
            <div class="info_item flex aic">
              <div class="info_item_title">税号：</div>
              <div class="info_item_content">{{ legForm.TaxNum ? legForm.TaxNum : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">开票地址：</div>
              <div class="info_item_content">{{ legForm.RegisteredAddress && legForm.RegisteredAddress.indexOf('$$')>-1 ? legForm.RegisteredAddress.replace('$$','') : legForm.RegisteredAddress.split('/')[0].replace(/,/g,'-') + '；' + legForm.RegisteredAddress.split('/')[1] }}</div>
            </div>
            <div class="info_item flex aic">
              <div class="info_item_title">开户电话：</div>
              <div class="info_item_content">{{ legForm.BillingTel ? legForm.BillingTel : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">开户行：</div>
              <div class="info_item_content">{{ legForm.BillingBank ? legForm.BillingBank : '' }}</div>
            </div>
            <div class="info_item flex aic">
              <div class="info_item_title">银行账号：</div>
              <div class="info_item_content">{{ legForm.BillingAccount ? legForm.BillingAccount : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">联行号：</div>
              <div class="info_item_content">{{ legForm.BillingCnaps ? legForm.BillingCnaps : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">股东结构：</div>
              <div class="info_item_content">{{ legForm.ShareholderStruct ? legForm.ShareholderStruct : ''}}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">说明：</div>
              <div class="info_item_content">{{ legForm.Explain ? legForm.Explain : ''}}</div>
            </div>
          </div>

          <div class="info_Box_left">
            <div class="info_item flex">
              <div class="info_item_title">公司状态：</div>
              <div class="info_item_content">{{ legForm.CompanyStuat ? legForm.CompanyStuat : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">业务类型：</div>
              <div class="info_item_content">{{ legForm.BusinessUnit ? legForm.BusinessUnit : '' }}</div>
            </div>
            <div class="info_item flex">
              <div class="info_item_title">公司属性：</div>
              <div class="info_item_content">{{ legForm.CompanyPro ? legForm.CompanyPro : '' }}</div>
            </div>
            <div class="info_tc_item flex">
              <div class="info_item flex">
                <div class="info_item_title">法人/负责人：</div>
                <!-- <el-popover placement="right" width="100" trigger="click">
                  <el-table :data="gridData" v-loading="gridloading">
                    <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                  </el-table>
                  <div class="greenName cp" slot="reference" @click="getPhone(legForm.LegalPersonId)" v-show="legForm.LegalPersonId && legForm.LegalPerson" title="点击查看联系方式">{{ legForm.LegalPerson }}</div>
                </el-popover> -->
                <div>{{legForm.LegalPerson}}</div>
                <div v-if="!legForm.LegalPersonId && legForm.LegalPerson">{{ legForm.LegalPerson }}</div>
              </div>
              <div class="info_item flex">
                <div class="info_item_title">资质管理员：</div>
                <el-popover placement="right" width="100" trigger="click">
                  <el-table :data="gridData" v-loading="gridloading">
                    <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                  </el-table>
                  <div class="greenName cp" slot="reference" @click="getPhone(legForm.QualificationManagerId)" v-show="legForm.QualificationManagerId && legForm.QualificationManager" title="点击查看联系方式">{{ legForm.QualificationManager }}</div>
                </el-popover>
                <div v-if="!legForm.QualificationManagerId && legForm.QualificationManager">{{ legForm.QualificationManager }}</div>
              </div>
            </div>

            <div class="info_tc_item flex">
              <div class="info_item flex">
                <div class="info_item_title">公章管理员：</div>
                <el-popover placement="right" width="100" trigger="click">
                  <el-table :data="gridData" v-loading="gridloading">
                    <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                  </el-table>
                  <div class="greenName cp" slot="reference" @click="getPhone(legForm.StampKeeperId)" v-show="legForm.StampKeeperId && legForm.StampKeeper" title="点击查看联系方式">{{ legForm.StampKeeper }}</div>
                </el-popover>
                <div v-if="!legForm.StampKeeperId && legForm.StampKeeper">{{ legForm.StampKeeper }}</div>
              </div>
              <!-- <div class="info_item flex">
                <div class="info_item_title">财报/审计报告管理员：</div>
                <el-popover placement="right" width="100" trigger="click">
                  <el-table :data="gridData" v-loading="gridloading">
                    <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                  </el-table>
                  <div class="greenName cp" slot="reference" @click="getPhone(legForm.FinancialStatEkeeperid)" v-show="legForm.FinancialStatEkeeperid && legForm.FinancialStatEkeeper" title="点击查看联系方式">{{ legForm.FinancialStatEkeeper }}</div>
                </el-popover>
              </div> -->
            </div>

            <div class="info_tc_item flex">
              <div class="info_item flex">
                <div class="info_item_title">合同章管理员：</div>
                <el-popover placement="right" width="100" trigger="click">
                  <el-table :data="gridData" v-loading="gridloading">
                    <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                  </el-table>
                  <div class="greenName cp" slot="reference" @click="getPhone(legForm.ContractSealKeeperid)" v-show="legForm.ContractSealKeeperid && legForm.ContractSealKeeper" title="点击查看联系方式">{{ legForm.ContractSealKeeper }}</div>
                </el-popover>
                <div v-if="!legForm.ContractSealKeeperid && legForm.ContractSealKeeper">{{ legForm.ContractSealKeeper }}</div>
              </div>
              <!-- <div class="info_item flex">
                <div class="info_item_title">法人身份证保管员：</div>
                <el-popover placement="right" width="100" trigger="click">
                  <el-table :data="gridData" v-loading="gridloading">
                    <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                  </el-table>
                  <div class="greenName cp" slot="reference" @click="getPhone(legForm.CorporIdcardKeeperid)" v-show="legForm.CorporIdcardKeeperid && legForm.CorporIdcardKeeper" title="点击查看联系方式">{{ legForm.CorporIdcardKeeper }}</div>
                </el-popover>
              </div> -->
            </div>

            <div class="info_tc_item flex">
              <div class="info_item">
                <div class="info_item_title">营业执照：</div>
                <el-image v-if="legForm.BusiLicenseUrl" class="info_item_img cp" :src="headPath + legForm.BusiLicenseUrl" :preview-src-list="srcList" @click="previewImg(legForm.BusiLicenseUrl)">
                </el-image>
              </div>
              <div class="info_item">
                <div class="info_item_title">开户许可证：</div>
                <el-image v-if="legForm.OpenLicenseUrl" class="info_item_img cp" :src="headPath + legForm.OpenLicenseUrl" :preview-src-list="srcList" @click="previewImg(legForm.OpenLicenseUrl)">
                </el-image>
              </div>
            </div>

            <div class="info_tc_item flex">
              <div class="info_item">
                <div class="info_item_title flex">
                  人力资源许可证：
                  <div class="info_item_content">{{legForm.HumanResoLicenUrl ? '有' : '无'}} <span style="color: red;" v-if="legForm.HumanResoLicenEndTime">({{ dueDays1>0 ? '距到期：' + parseInt(dueDays1) + '天' : '已过期：' + -parseInt(dueDays1) + '天'}})</span></div>
                </div>
                <el-image v-if="legForm.HumanResoLicenUrl" class="info_item_img cp" :src="headPath + legForm.HumanResoLicenUrl" :preview-src-list="srcList" @click="previewImg(legForm.HumanResoLicenUrl)">
                </el-image>
              </div>
              <div class="info_item">
                <div class="info_item_title flex">
                  劳务派遣证：
                  <div class="info_item_content">{{legForm.LaborlicenseUrl ? '有' : '无'}} <span style="color: red;" v-if="legForm.LaborlicenseEndTime">({{ dueDays2>0 ? '距到期：' + parseInt(dueDays2) + '天' : '已过期：' + -parseInt(dueDays2) + '天'}})</span></div>
                </div>
                <el-image v-if="legForm.LaborlicenseUrl" class="info_item_img cp" :src="headPath + legForm.LaborlicenseUrl" :preview-src-list="srcList" @click="previewImg(legForm.LaborlicenseUrl)">
                </el-image>
              </div>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">其他资质：</div>
              <div class="info_item_sys cp">
                <div v-for="(item,index) in threeSysInfo" :key="index" @click="down(item.Url)" style="margin:2px 0 12px;" title="点击下载附件">{{ item.FileType }}</div>
              </div>
              <div v-if="threeSysInfo.length==0">暂无资质附件</div>
            </div>

            <!-- <div class="getMore cp">点击查看更多其他资质</div> -->

          </div>
        </div>

        <div class="info_Box flex" v-if="activeName=='second'">
          <div class="info_Box_left">
            <!-- <div class="info_item flex">
              <div class="info_item_title">开票类型：</div>
              <div class="info_item_content">{{ legForm2.BillingType ? legForm2.BillingType : '' }}</div>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">开票内容：</div>
              <div class="info_item_content">{{ legForm2.BillingContent ? legForm2.BillingContent : '' }}</div>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">通用税率：</div>
              <div class="info_item_content">{{ legForm2.TaxRate ? legForm2.TaxRate : '' }}</div>
            </div> -->

            <div class="info_item flex">
              <div class="info_item_title">纳税人分类：</div>
              <div class="info_item_content">{{ legForm2.TaxpayerClass ? legForm2.TaxpayerClass : '' }}</div>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">纳税会计：</div>
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <div class="greenName cp" slot="reference" @click="getPhone(legForm2.TaxAccountingId)" v-show="legForm2.TaxAccountingId && legForm2.TaxAccounting" title="点击查看联系方式">{{ legForm2.TaxAccounting }}</div>
              </el-popover>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">开票负责人：</div>
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <div class="greenName cp" slot="reference" @click="getPhone(legForm2.BillingOfficerId)" v-show="legForm2.BillingOfficerId && legForm2.BillingOfficer" title="点击查看联系方式">{{ legForm2.BillingOfficer }}</div>
              </el-popover>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">财报/审计报告管理员：</div>
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <div class="greenName cp" slot="reference" @click="getPhone(legForm2.FinancialStatEkeeperid)" v-show="legForm2.FinancialStatEkeeperid && legForm2.FinancialStatEkeeper" title="点击查看联系方式">{{ legForm2.FinancialStatEkeeper }}</div>
              </el-popover>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">审计报告：</div>
              <div class="greenName cp" v-if="legForm2.AttachFinanStateUrl" @click="down(legForm2.AttachFinanStateUrl)">点击下载</div>
              <div v-else>暂未上传审计报告</div>
            </div>

            <div class="info_item flex">
              <div class="info_item_title">说明：</div>
              <div class="info_item_content">{{ legForm2.Explain ? legForm2.Explain : '' }}</div>
            </div>

            <el-table :data="fftableData" border class="doc_table" style="width: 391px;">
              <el-table-column prop="Name" label="方案名称" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="BillingType" label="开票类型" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="BillingContent" label="开票内容" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="TaxRate" label="适用税率" width="90" :show-overflow-tooltip="true" align="center">
              </el-table-column>
            </el-table>


          </div>

          <div class="info_Box_left">
            <!-- <div class="info_item flex">
              <div class="info_item_title">开票资料：</div>
              <div class="info_item_content">
                <span>{{ legForm2.BillingInfor ? legForm2.BillingInfor : '' }}</span>
                <span class="copy cp" style="margin-left: 10px;" v-if="legForm2.BillingInfor" @click="copy(legForm2.BillingInfor)">复制</span>
              </div>
            </div> -->
            <div>
              <div class="bankTitle">基本户</div>
              <div class="flex aic bankInfo">
                <div>开户行：</div>
                <div class="info_item_content" style="margin-right: 20px;">{{ legForm2.BaOpenBank }}</div>
                <div>账号：</div>
                <div class="info_item_content" style="margin-right: 20px;">{{ legForm2.BaAccount }}</div>
                <div>缺省：</div>
                <div class="info_item_content" style="margin-right: 20px;">{{ legForm2.BakIsDaf ? '是' : legForm2.BakIsDaf == false ? '否' : '' }}</div>
              </div>
            </div>

            <div v-if="legForm2.CommonAccount.length>0">
              <div class="bankTitle">一般户</div>
              <div v-for="(item,index) in legForm2.CommonAccount" :key="index">
                <div class="flex aic bankInfo" v-show="!item.BaIsShow">
                  <div>开户行：</div>
                  <div class="info_item_content" style="margin-right: 20px;">{{ item.BaOpenBank }}</div>
                  <div>账号：</div>
                  <div class="info_item_content" style="margin-right: 20px;">{{ item.BaAccount }}</div>
                  <div>缺省：</div>
                  <div class="info_item_content" style="margin-right: 20px;">{{ item.BakIsDaf ? '是' : '否'}}</div>
                </div>
              </div>
            </div>

            <div class="info_item flex" style="margin-top: 20px;">
              <div class="info_item_title">返税规则：</div>
              <!-- <el-image class="info_item_img2 cp" v-if="legForm2.TaxRebatePolicyUrl" :src="headPath + legForm2.TaxRebatePolicyUrl" :preview-src-list="srcList" @click="previewImg(legForm2.TaxRebatePolicyUrl)">
              </el-image> -->
              <pdf v-if="legForm2.TaxRebatePolicyUrl" :src="headPath + legForm2.TaxRebatePolicyUrl" :page="1" style="width:100%" ref="pdf"></pdf>
              <div v-else>
                <el-empty description="暂未上传返税规则"></el-empty>
              </div>
            </div>
          </div>
        </div>

        <div class="info_Box" v-if="activeName=='third'">
          <div>
            <!-- <div class="success_title">成功案例</div> -->
            <el-table :data="tableData" border class="doc_table">
              <el-table-column prop="CustomeName" label="客户" width="140" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="CustomeArea" label="客户地区" width="180" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                  {{ scope.row.CustomeArea ? scope.row.CustomeArea.replace(/,/g,'-') : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="CustomerIndustry" label="客户行业" width="120" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                  {{ scope.row.CustomerIndustry ? scope.row.CustomerIndustry.replace(/,/g,'-') : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="ContractSubjectName" label="主体名称" width="140" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="BusiType" label="业务类型" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="CooperationTime" label="合作开始时间" width="100" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                  {{ scope.row.CooperationTime ? scope.row.CooperationTime.split('T')[0] : ''}}
                </template>
              </el-table-column>
              <el-table-column prop="CooperationStue" label="当前状态" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="Details" label="说明" width="240" align="center" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column label="附件" width="100" align="center">
                <template slot-scope="scope">
                  <span class="info_item_sys cp" v-if="scope.row.DetailsUrl" @click="down(scope.row.DetailsUrl)">下载</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="block">
              <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
            </div>
          </div>
        </div>

        <div class="info_Box" v-if="activeName=='fourth'">
          <div style="margin-top: 10px;">
            <div class="success_title" style="margin-bottom: 5px;">合同模板</div>
            <div v-for="(item,index) in tracttemplist" :key="index">{{ item.ContractProType }}：<span class="info_item_sys cp" @click="down(item.ContractUrl)" style="margin-bottom: 10px;">下载</span>
            </div>
            <div v-if="tracttemplist.length == 0">
              <el-empty description="暂未上传合同模板"></el-empty>
            </div>
          </div>
        </div>


        <div class="info_Box" v-if="activeName=='fifth'">
          <pdf v-if="quoPdfSrc" :src="headPath + quoPdfSrc" :page="1" style="width:90%" ref="pdf"></pdf>
          <div v-else>
            <el-empty description="暂未上传报价指导"></el-empty>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import pdf from 'vue-pdf' //引入下载的vue-pdf
  export default {
    components: {
      pdf
    },
    data() {
      return {
        activeName: 'first',
        Id: '', //基本信息ID
        FinanceID: '', //财务信息ID
        width: 0,
        legForm: { //基本信息
          Id: '',
          CompanyName: '', //公司名称
          RegisteredCapital: '', //注册资金
          RegisteredAddress: '', //注册地点
          RegisteredTime: '', //注册时间
          BusinessTerm: '', //营业期限
          BusinessScope: '', //经营范围
          Explain: '', //说明
          CompanyStuat: '', //公司状态
          BusinessUnit: [], //业务类型
          CompanyPro: '', //公司属性
          LegalPerson: '', //法人/负责人
          QualificationManager: '', //资质管理员
          StampKeeper: '', //公章保管员
          ContractSealKeeper: '', //合同章管理员
          CorporIdcardKeeper: '', //法人身份证保管员
          FinancialStatEkeeper: '', //财报/审计报告管理员
          BusiLicenseUrl: '', //营业执照
          OpenLicenseUrl: '', //开户许可证url
          HumanResoLicenUrl: '', //人力资源许可证
          LaborlicenseUrl: '', //劳务许可证
          HumanResoLicenEndTime: '', //人力资源许可证到期时间
          LaborlicenseEndTime: '', //劳务许可证到期时间
          TaxNum: '', //税号
          BillingAdd: '', //开票地址
          BillingTel: '', //电话
          BillingBank: '', //开户行
          BillingAccount: '', //账号
          BillingCnaps: '', //联行号
        },
        legForm2: { //财务信息
          Id: '',
          LegalId: '', //legForm李的Id
          BillingType: [], //开票类型
          BillingContent: [], //开票内容
          TaxRate: '', //适用税率
          TaxpayerClass: '', //纳税人分类
          TaxAccounting: '', //报税会计
          BillingOfficer: '', //开票负责人
          TaxRebatePolicyUrl: '', //返税政策
          BillingInfor: '', //开票资料
          FinancialStatEkeeper: '',
          FinancialStatEkeeperid: '',
          Explain: '', //说明
          BaOpenBank: '', //开户行
          BaAccount: '', //账号
          BakIsDaf: '', //是否缺省
          BaIsShow: '', //是否隐藏
          CommonAccount: []
        },
        address: '',
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        srcList: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
        tableData: [{
          date: 1,
          name: 'aaa',
          address: 'bbbb'
        }],
        headPath: this.$store.state.EMP.docPath,
        dueDays1: 0,
        dueDays2: 0,
        threeSysInfo: [], //三体系信息
        totalCount: 0,
        listQuery: {
          ContractSubjectName: '',
          pageNum: 1,
          pageSize: "10"
        },
        tracttemplist: [], //合同模板列表
        quoPdfSrc: '',
        gridData: [],
        gridloading: false,
        fftableData: [], //财务开票方案
      }
    },
    created() {
      if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.Id = this.$route.query.Id;
        this.FinanceID = this.$route.query.FinanceID
        this.getlegalsubjectdetails();
      }
    },
    mounted() {
      this.width = Number(document.body.clientWidth);
    },
    methods: {
      //获取三体系列表
      getfilelist() {
        let data = {
          BusinessId: this.legForm.Id,
          BusiType: '1',
          pageNum: 1,
          pageSize: "100000"
        }
        xz.getfilelist(data).then(res => {
          if (res.status == 'ok') {
            this.threeSysInfo = res.data.data;
          } else {
            this.threeSysInfo = []
            this.$message.error('获取三体系信息失败')
          }
        })
      },
      //获取报价指导
      getfilelist2() {
        let data = {
          BusinessId: '报价指导',
          pageNum: 1,
          pageSize: "10"
        }
        xz.getfilelist(data).then(res => {
          if (res.status == 'ok' && res.data.data.length > 0) {
            this.quoPdfSrc = res.data.data[0].Url;
          } else {
            this.quoPdfSrc = ''
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      handleClick(tab, event) {
        if (this.activeName == 'first') {
          this.getlegalsubjectdetails();
        } else if (this.activeName == 'second') {
          this.getlegalfinancedetails();
          this.getbslist();
        } else if (this.activeName == 'third') {
          this.getcustomecaselist();
        } else if (this.activeName == 'fourth') {
          this.getcontracttemplist();
        } else if (this.activeName == 'fifth') {
          this.getfilelist2();
        }
      },
      //获取基本信息
      getlegalsubjectdetails() {
        xz.getlegalsubjectdetails(this.Id).then(res => {
          if (res.status == 'ok') {
            this.legForm = res.data.entInfo1;
            if (res.data.entInfo1.HumanResoLicenEndTime) {
              this.dueDays1 = (new Date(res.data.entInfo1.HumanResoLicenEndTime).valueOf() - new Date().valueOf()) / (24 * 60 * 60 * 1000)
            }
            if (res.data.entInfo1.LaborlicenseEndTime) {
              this.dueDays2 = (new Date(res.data.entInfo1.LaborlicenseEndTime).valueOf() - new Date().valueOf()) / (24 * 60 * 60 * 1000)
            }
            this.getfilelist();
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //获取财务信息
      getlegalfinancedetails() {
        xz.getlegalfinancedetails(this.Id).then(res => {
          if (res.status == 'ok') {
            if (!this.isNull(res.data)) {
              res.data.BaIsShow = res.data.BaIsShow ? eval(res.data.BaIsShow) : false
              res.data.BakIsDaf = res.data.BakIsDaf ? eval(res.data.BakIsDaf) : false
            }
            if (!this.isNull(res.data.CommonAccount)) {
              res.data.CommonAccount = eval(res.data.CommonAccount)
              this.legForm2 = res.data;
              this.legForm2.CommonAccount.forEach(element => {
                element.BakIsDaf = element.BakIsDaf ? eval(element.BakIsDaf) : false
                element.BaIsShow = element.BaIsShow ? eval(element.BaIsShow) : false
              });
            } else {
              this.legForm2 = res.data;
            }
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //获取方案列表
      getbslist() {
        let data = {
          LegafId: this.Id
        }
        xz.getbslist(data).then(res => {
          if (res.status == 'ok') {
            this.fftableData = res.data.data
          } else {
            this.$message.error('获取方案列表出错')
          }
        })
      },
      //获取案例列表
      getcustomecaselist() {
        this.listQuery.ContractSubjectName = this.legForm.CompanyName;
        xz.getcustomecaselist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0
          }
        })
      },
      //获取合同模板列表
      getcontracttemplist() {
        let data = {
          pageNum: 1,
          pageSize: '10'
        }
        xz.getcontracttemplist(data).then(res => {
          if (res.status == 'ok') {
            this.tracttemplist = res.data.data;
          } else {
            this.tracttemplist = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getcustomecaselist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getcustomecaselist();
      },
      previewImg(url) {
        this.srcList = [this.headPath + url]
      },
      down(url) {
        if (url) {
          let d = url.replace("\"", "").replace("\"", "");
          var path = this.headPath + d;
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
        } else {
          this.$message.warning('暂未上传附件')
        }

      },
      getPhone(id) {
        this.gridloading = true;
        let dtlQuery = {
          mainuserid:'',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res => {
          if (res.status == 'ok') {
            this.gridData = [{
              phone: res.msg.Strmobile
            }]
            this.gridloading = false;
          } else {
            this.$message.error('获取联系方式失败')
            this.gridData = []
            this.gridloading = false;
          }
        })
      },
      copy(content) {
        navigator.clipboard.writeText(content).then(() => {
          this.$message.success('复制成功')
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_Box_left {
    width: 50%;
    max-width: 500px;
    padding: 10px 30px 10px 10px;
  }

  .info_item {
    margin-bottom: 16px;
    font-size: 14px;
  }

  .info_item_title {
    color: #333;
    min-width: 5em;
  }

  .info_item_content {
    color: #333;
    font-weight: bold;
    font-size: 14px;
  }

  .info_tc_item .info_item {
    width: 49%;
    margin-right: 10px;
  }

  .info_item_img {
    width: 100px;
    height: 100px;
    margin-top: 16px;
  }

  .info_item_img2 {
    width: 450px;
    height: 450px;
  }

  .info_item_sys {
    color: #598DE7;
  }

  .getMore {
    width: 400px;
    text-align: center;
    background: #fff;
    border: 1px solid #CDCDCD;
    margin-top: 50px;
    height: 32px;
    line-height: 32px;
    border-radius: 5px;
  }

  .success_title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .ml {
    margin-left: 30px;
  }

  .mt {
    margin-top: 10px;
  }

  .greenName {
    font-weight: bold;
  }

  .copy {
    color: #19bd92;
  }

  .bankTitle {
    font-size: 14px;
    color: #333;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .bankInfo {
    margin-bottom: 10px;
  }
</style>
<style>
  .page_legalSubjectInfo .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_legalSubjectInfo .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
</style>